import SectionSkeleton from "../../components/ui/SectionSkeleton"
import { Fragment, lazy, Suspense, useState } from "react"
import InputFieldB from "../../components/ui/InputFieldB"
import { contactUsSchema } from "../../utils/velidations"
import ReCAPTCHA from "react-google-recaptcha"
import Images from "../../assets/js/Images"

import {
  Box, Button, Container, Divider, Grid2 as Grid,
  Skeleton, styled, Typography
} from "@mui/material"

const TopBannerB = lazy(() => import("../../components/common/TopBannerB"))
const Iframe = styled("iframe")(() => ({}))

function HelpCenter() {
  const [loading, setLoading] = useState(true)
  const [helperText, setHelperText] = useState([])

  // Handle forgot password 
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)
    const result = contactUsSchema.safeParse(formData)
    if (!result.success) {
      const groupedErrors = {}
      result.error.issues.forEach((issue) => {
        const key = issue.path[0]
        if (!groupedErrors[key]) {
          groupedErrors[key] = []
        }
        groupedErrors[key].push(issue.message)
      })
      setHelperText(groupedErrors)
      return
    }
    setHelperText([])
  }

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.contact}
          headline="Need Assistance? We're Here for You"
        />
      </Suspense>

      <Box
        component="section"
        sx={{ py: { xs: 5, lg: 10 }, px:{xs: 2, lg: 0} }}
      >
        <Box sx={{margin:"0 auto"}} maxWidth="xl">
          <Box
            sx={{
              mb: 4,
              mx: "auto",
              display: "flex",
              maxWidth: "900px",
              alignItems: "center",
              gap: { xs: 1, lg: 3 },
              flexDirection: "column",
            }}
          >
            <Typography
              color="other.color1"
              variant="displayLarge"
            >Be in Touch !
            </Typography>
            <Typography
              color="#7a8a9e"
              variant="bodyLead"
            >Don&apos;t be a stranger, send us a line !
            </Typography>
            <Divider
              sx={{
                width: "150px",
                borderWidth: "1px",
                borderColor: "secondary.main"
              }}
            />
          </Box>
          <Box
            sx={{
              label: {
                mb: "14px",
                color: "other.color1",
                fontSize: "15px",
                fontWeight: "600"
              },
              ".MuiInputBase-root.MuiInputBase-root": {
                p: "10px 14px",
                borderRadius: "0",
                bgcolor: "#ECEFF3 !important",
                borderColor: "transparent",
              },
              ".MuiInputBase-root.Mui-focused": {
                bgcolor: "transparent !important",
                borderColor: "secondary.dark",
              },
              "[placeholder]": {
                fontSize: "15px",
                fontWeight: "300",
                color: "#888888",
              },
              ".MuiInputBase-input.MuiInputBase-input": {
                padding: "0",
                height: "30.56px"
              }
            }}
          >
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Grid container spacing={3} component="form" onSubmit={handleSubmit}>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <InputFieldB
                      type="text"
                      name="fullName"
                      label="full name*"
                      inputtype="InputFieldB"
                      helperText={helperText}
                      placeholder="e.g. John Doe"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <InputFieldB
                      name="email"
                      type="email"
                      label="your email*"
                      inputtype="InputFieldB"
                      helperText={helperText}
                      placeholder="Email address"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <InputFieldB
                      name="phone"
                      type="number"
                      label="your phone*"
                      inputtype="InputFieldB"
                      helperText={helperText}
                      placeholder="Fill number"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <InputFieldB
                      type="text"
                      name="interested"
                      inputtype="InputFieldB"
                      helperText={helperText}
                      label="I'm interested in*"
                      placeholder="Learning more..."
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <InputFieldB
                      name="message"
                      type="textarea"
                      label="Your Message*"
                      inputtype="InputFieldB"
                      helperText={helperText}
                      placeholder="Text here..."
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_KEY} />
                    {helperText?.["g-recaptcha-response"] &&
                      <Typography
                        mt={0.5}
                        fontSize="14px"
                        color="error.main"
                      >{helperText?.["g-recaptcha-response"]}
                      </Typography>
                    }
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <Button
                      sx={{
                        width: "100%",
                        color: "white",
                        fontWeight: "600",
                        justifyContent: "center",
                        bgcolor: "secondary.dark",
                        transition: "all 350ms ease",
                        ":hover": { bgcolor: "other.color1" }
                      }}
                      size="large"
                      type="submit"
                      color="secondary"
                      variant="contained"
                    >Send Message
                    </Button>
                    <Typography
                      sx={{
                        mt: 4,
                        color: "#7A8A9E",
                        fontStyle: "italic",
                        textAlign: "center",
                      }}
                    >Your email address will not be published.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Iframe
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: loading ? "none" : "block",
                    minHeight: { xs: "320px", lg: "unset" }
                  }}
                  title="map"
                  onLoad={() => { setLoading(false) }}
                  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d-93.63905729999999!3d41.998507000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                />
                {loading &&
                  <Skeleton
                    sx={{
                      height: "100%",
                      transform: "none",
                      minHeight: { xs: "320px", lg: "unset" }
                      // aspectRatio: "1/0.7",
                    }}
                  />
                }
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Fragment>
  )
}

export default HelpCenter